//from https://dev.to/alejomartinez8/how-to-load-a-hash-fragment-to-an-anchor-name-in-react-especially-in-first-loading-g3i
import { useEffect } from 'react';

export function useHashFragment(offset = 0, trigger = true) {
  useEffect(() => {
    const timer = setTimeout(() => {
      scrollToHashElement();
    }, 300);

    const scrollToHashElement = () => {
      const { hash } = window.location;
      const elementToScroll = document.getElementById(hash?.replace('#', ''));

      if (!elementToScroll) return;

      elementToScroll.scrollIntoView({ behavior: 'smooth' });
    };

    return () => clearTimeout(timer);
  }, [trigger]);
}
